import type { FaireProductEntity } from "../../entity_types/product";

export const p_a6hkujpyap: FaireProductEntity = {
  token: "p_a6hkujpyap",
  type: "product",
  name: "Toddler Beach Bum Cotton Graphic Tee - customizable",
  brandToken: "b_8kumxdqk",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f80155d884e0b039d8e5d3a32e149ebfacb1c7c30514e174efb71e3c5f4b4919.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9cab0827d7d1a06518e0f109d2fa78e7d4fd2c6e453feceebb8d5e8dd49916f.png",
    "https://cdn.faire.com/fastly/00f9bb9cdde37adfddff379d5e163ede80b73b8476b21f2c339eb6e0fda7b5f6.png",
    "https://cdn.faire.com/fastly/838353497667213a6702ad70acfcf97b9627a6570e41abc4921578dd48f5b13e.png",
    "https://cdn.faire.com/fastly/63b7e0644a68858e02020272628521340836ae5aab428c9a7283bc6d9748af07.png",
  ],
  priceDollars: 13.17,
  description:
    "This short sleeve tee for both babies or toddlers is a very popular graphic for all beach shops!  We often customize with your beach or city name underneath the print.  It comes in multiple colors and is a best seller for us every summer!\n\n*Printed on Rabbit Skins brand 100% Combed Ringspun Cotton Fine Jersey\n\nFabrication: 4.5 oz. 100% combed ringspun cotton fine jersey • Ash is 99/1; CVC Colors are 60/40; Heather is 90/10 combed ringspun cotton/polyester • Ash and White are sewn with 100% cotton thread\n\nFeatures: Topstitched ribbed collar • Shoulder-to-shoulder self-fabric back neck tape • Double needle sleeves and bottom hem • Side seam construction • EasyTear™ label\n\nSafety: CPSIA compliant tracking label in side seam\n\nCare: Machine wash • Tumble dry low\n\nFit: Toddler Unisex\n\n*Items are silk screen printed with water based ink. \n\n *If you'd like other colored tees, please inquire and we can send you more options!\n",
  tags: [],
  msrpDollars: 26.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:07.806Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
